import * as types from '../actions/chickenDashAction';

const initialState = {
  restaurantUuid: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  interval: null,
  intervalEnd: null,
  timezone: null,
  startTimeInterval: null,
  endTimeInterval: null,
  cookingMethod: 'FRIED',
  chickenTypes: [],
  period: 'DAY',
  settings: {},
  activeTab: 'summaryStatus',
  charts: {
    summaryHTR: {
      groupTitle: 'Hold Time Distribution by Product',
      rows: null,
      options: {},
    },
    wasteSummary: {
      groupTitle: 'Waste Result',
      rows: null,
      options: {},
    },
    wasteByDayPart: {
      groupTitle: 'Waste by Products & Daypart',
      rows: null,
      options: {},
    },
    detailedHoldingTime: {
      groupTitle: 'Average Hold Time Trend',
      rows: null,
      options: {},
    },
    detailedWaste: {
      groupTitle: 'Waste Trend',
      rows: null,
      options: {},
    },
    holdTimeDistr: {
      groupTitle: 'Hold Time Distribution',
      rows: null,
      options: {},
    },
    averageHoldTime: {
      groupTitle: 'Average Hold Time by Product & Daypart',
      rows: null,
      options: {},
    },
    panCyclesAverage: {
      groupTitle: 'Average Pan Cycles per Hour with no filters - by Daypart & Product',
      rows: null,
      options: {},
    },
    panCycles: {
      groupTitle: 'Pan Cycles with no filters',
      rows: null,
      options: {},
    },
  },
  sortModel: {
    cooked: {
      sortBy: 'value',
      orderDirection: 'DESC',
    },
    waste: {
      sortBy: 'value',
      orderDirection: 'DESC',
    },
    recommendations: {
      sortBy: 'value',
      orderDirection: 'DESC',
    },
    containers: {
      sortBy: 'value',
      orderDirection: 'DESC',
    },
    trays: {
      sortBy: 'value',
      orderDirection: 'DESC',
    },
    conveyors: {
      sortBy: 'utilized',
      orderDirection: 'DESC',
    },
    prs: {
      sortBy: 'count',
      orderDirection: 'DESC',
    },
    mtrs: {
      sortBy: 'count',
      orderDirection: 'DESC',
    },
    stockOut: {
      sortBy: 'time',
      orderDirection: 'DESC',
    },
    taskDelay: {
      sortBy: 'averageTaskDelay',
      orderDirection: 'DESC',
    },
    fryerCycles: {
      sortBy: 'total',
      orderDirection: 'DESC',
    },
    grillCycles: {
      sortBy: 'total',
      orderDirection: 'DESC',
    },
    entreeChutes: {
      sortBy: 'packages',
      orderDirection: 'DESC',
    },
  },
  tabsModel: {
    cooked: 'production',
    recommended: 'production',
    containers: 'production',
    conveyors: 'inbound',
    entreeChutes: 'packages',
  },
};

const chickenDashReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_CHICKEN_DASHBOARD_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_CHICKEN_DASHBOARD_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.SET_CHICKEN_DASHBOARD_SORT_BY:
      return {
        ...state,
        sortModel: {
          ...state.sortModel,
          [action.payload.section]: {
            ...state.sortModel[action.payload.section],
            sortBy: action.payload.sortBy,
          },
        },
      };

    case types.SET_CHICKEN_DASHBOARD_ORDER_DIRECTION:
      return {
        ...state,
        sortModel: {
          ...state.sortModel,
          [action.payload.section]: {
            ...state.sortModel[action.payload.section],
            orderDirection: action.payload.orderDirection,
          },
        },
      };

    case types.SET_CHICKEN_DASHBOARD_SECTION_TAB:
      return {
        ...state,
        tabsModel: {
          ...state.tabsModel,
          [action.payload.section]: action.payload.tab,
        },
      };

    case types.RESET_CHICKEN_DASHBOARD_STORE:
      return {
        ...state,
        ...initialState,
        settings: state.settings,
      };

    default:
      return state;
  }
};

export default chickenDashReducer;
